module.exports = __webpack_public_path__ + "img/step_bg.5a463fe0.png";